import { render } from "./TabPlantDetailsControlBMS.vue?vue&type=template&id=50342f66"
import script from "./TabPlantDetailsControlBMS.vue?vue&type=script&lang=js"
export * from "./TabPlantDetailsControlBMS.vue?vue&type=script&lang=js"

import "./TabPlantDetailsControlBMS.vue?vue&type=style&index=0&id=50342f66&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__